// import library
import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
// import files
import { env } from "../../env";
import { NavLink } from "react-router-dom";
import ErrorModal from "../../components/Modal/ErrorModal";
import SuccessModal from "../../components/Modal/SuccessModal";
import { logEvent } from "../../analytics";

const ForgotPassword = () => {
    // variables
    const { t } = useTranslation();
    const errorStyle = "text-danger-normal font-bold text-xs mt-0.5";
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [credentialError, setCredentialError] = useState("");
    const [focuField, setFocusField] = useState('none');
    const [inputs, setInputs] = useState({
        email: "",
    });

    // functions
    const validateValues = (inputValues) => {
        let errors = {};
        if(inputValues.email.trim().length === 0) {
            errors.email = true;
        }
        return errors;
    };
    const handleChange = (e) => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        });
    };
    const handleFocus = (e, name) => {
        e.preventDefault();
        setFocusField(name);
    };
    const handleErrorModalDataFromChild = () => {
        setCredentialError("");
    };
    const handleSuccessModalDataFromChild = () => {
        setSuccessMessage("");
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFocusField('none');
        setSuccessMessage("");
        setCredentialError('');
        setErrors(validateValues(inputs));

        if(Object.keys(validateValues(inputs)).length === 0 ) {
            const baseUrl = env.REACT_APP_API_URL;
            const headers = {
                "Content-Type" : "multipart/form-data"
            };

            axios.post(baseUrl+"/api/user/SendForgotPasswordEmail", {
                email: inputs.email,
                language: localStorage.getItem('locale') || 'en'
            }, { headers })
            .then((response) => {
                if(response.data.success === '1') {

                    logEvent('forgot_password_page', 'auth', 'forgot_password', inputs.email);

                    setSuccessMessage(t('reset password link sent to mail successfully'));
                } else if (response.data.success === '0') {
                    setCredentialError(t('email not registered please enter valid email'));
                }
                setTimeout(() => {
                    setCredentialError('');
                }, 5000);
            }).catch((error) => {
                if (error.response) {
                    setCredentialError(t('something went wrong'));
                    setTimeout(() => {
                        setSuccessMessage('');
                        setCredentialError('');
                    }, 5000);
                }
            });
        }
    };
    
    return (
        <div className="relative sm:max-w-full">
            <div className="bg-auth-light flex flex-col items-center justify-center min-h-screen top-0 h-full">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="bg-white p-4 sm:p-8 rounded-3xl shadow-around">
                        <div className="space-y-6">
                            <h1 className="text-center font-bold text-3xl capitalize">{ t('forgot password') }</h1>
                            <div className="text-light-400 text-center">{ t('enter your registered email address') }</div>
                            <div>
                                <div className={(focuField === 'email' ? 'border-blue-normal' : 'border-black-100') + " flex border rounded-lg p-3 items-center"}>
                                    <img className="mr-2" src={`../../../assets/icons/auth/mail.svg`} />
                                    <input onFocus={(e) => handleFocus(e, 'email')} name="email" type="text" value={inputs.email} onChange={(e) => handleChange(e)} className="border-none focus:outline-none w-full placeholder:text-gray-dark" placeholder={ t('enter address') } />
                                </div>
                                {errors.email ? (
                                    <p className={errorStyle}>
                                        { t('email field is required') }
                                    </p>
                                ) : null}
                            </div>
                            { (successMessage.length === 0) ? (
                                <div>
                                    <button type="submit" className="font-semibold text-white bg-blue-normal border-blue-normal rounded-lg text-center w-full py-3 px-2 cursor-pointer tracking-wide capitalize">
                                        { t('request reset link') }
                                    </button>
                                </div>
                            ) : null }
                            <div className="font-semibold text-blue-normal bg-white text-center w-full cursor-pointer tracking-wide capitalize">
                                <NavLink to="/">
                                    { t('cancel & go back') }
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {credentialError ? (
                <ErrorModal icon={'error'} title={'Error'} message={credentialError} borderColor={'B01030'} bgColor={'FCE8EC'} setModalDataFromChild={handleErrorModalDataFromChild}/>
            ) : null}
            {successMessage ? (
                <SuccessModal icon={'success'} title={'Success'} message={successMessage} borderColor={'25A35A'} bgColor={'EAFAF1'} setModalDataFromChild={handleSuccessModalDataFromChild}/>
            ) : null}
        </div>
    )
}

export default ForgotPassword;